import { FORTA_BLUE, FORTA_WHITE } from '../../../utils/colors';

import type { Theme } from '@mui/material/styles';

/**
 * Styles for the Autocomplete dropdown `Paper` (shadow + list options).
 *
 * MUI’s Listbox sets `[aria-selected="true"]` with `alpha(primary, action.selectedOpacity)` —
 * a light tint. We override with solid Forta blue; `!important` wins over those rules.
 */
export const AUTOCOMPLETE_PAPER_SX = {
  boxShadow: (theme: Theme) => theme.shadows[8],

  '& .MuiAutocomplete-option': {
    '&:hover:not([aria-selected="true"])': {
      backgroundColor: FORTA_BLUE.light2,
    },
    '&.Mui-focused:not([aria-selected="true"])': {
      backgroundColor: FORTA_BLUE.light2,
    },
    '&[aria-selected="true"]': {
      backgroundColor: `${FORTA_BLUE.primary} !important`,
      color: `${FORTA_WHITE} !important`,
    },
    '&[aria-selected="true"]:hover': {
      backgroundColor: `${FORTA_BLUE.primary} !important`,
      color: `${FORTA_WHITE} !important`,
    },
    '&[aria-selected="true"].Mui-focused': {
      backgroundColor: `${FORTA_BLUE.primary} !important`,
      color: `${FORTA_WHITE} !important`,
    },
    '&[aria-selected="true"].Mui-focusVisible': {
      backgroundColor: `${FORTA_BLUE.primary} !important`,
      color: `${FORTA_WHITE} !important`,
    },
  },
};
